module.exports = __webpack_public_path__ + "static/media/agejumpers.6cdc3b69.jpg";